export const TOKEN_DECIMALS = 9;
export const THE_GRAPH_URL = "https://api.thegraph.com/subgraphs/name/gazohx/gwsmainnetv11";
export const EPOCH_INTERVAL = 3250.1014;
// NOTE could get this from an outside source since it changes slightly over time
export const BLOCK_RATE_SECONDS = 13.2;

interface IAddresses {
  [key: number]: { [key: string]: string };
}

export const addresses: IAddresses = {
  1: {
    GWS_ADDRESS:                 "0x36F17BD0F7028c784b2e0C9B5a65dBe071a902d7",
    SGWS_ADDRESS:                "0xAfAF6d0503c093E80403Ba9FDAFBCD4B180e8162",
    DAI_ADDRESS:                 "0x6B175474E89094C44Da98b954EedeAC495271d0F",
    TREASURY_ADDRESS:            "0xF6b7EA4D234c545f061fF6D5a1a3d447eA8d8a46",
    BONDINGCALC_ADDRESS:         "0xB34bb944906E78184e3d86a20466d55830275728",
    STAKING_ADDRESS:             "0x842222BbaEcEb854993c5AD3F63e98fdFf214393",
    STAKING_HELPER_ADDRESS:      "0xEab694e9dDd75413523c457796932A7f56038cc5",
    DISTRIBUTOR_ADDRESS:         "0x18fD48C0791B67F993a4793FC0cbE22375B5dA5b",
    CIRCULATING_SUPPLY_ADDRESS:  "0x9CbBbd552379d990e9FA57Fe01a69c9E10a5d80c",
    REDEEM_HELPER_ADDRESS:       "0x45e689cFB510AEa0F57e9Dc17cD46E5A2F6F02E5",
  },
  42: {
    GWS_ADDRESS:                 "0x8F9F79D6731ba046983BDF4509E1BA4F449780F7",
    SGWS_ADDRESS:                "0x3a87C6F7508D6dCC252eA995a5004cb9d195c9D8",
    DAI_ADDRESS:                 "0x3c01e41055F43E3c5B4A8654a7dA22EAE5636336",
    TREASURY_ADDRESS:            "0x9174475348E529E3e7d4798E31aF4870fa53F3eE",
    BONDINGCALC_ADDRESS:         "0x5709caDbD7D31e857ab47254C4c3FE7771B5D7C6",
    STAKING_ADDRESS:             "0x111B4Cc66cCfB0f2D61E463cD0f49054c6F81926",
    STAKING_HELPER_ADDRESS:      "0x6Fac8d72779e4F1d604353a85db3355456E4F7d6",
    DISTRIBUTOR_ADDRESS:         "0xDb7Ac76dce48A315D37216B96d2e199183DE55B9",
    CIRCULATING_SUPPLY_ADDRESS:  "0x4cd5E579998abAd14ED885F46CD9fcfd56331aCA",
    REDEEM_HELPER_ADDRESS:       "0xa1a1980e4038d1Fc9717f944e2De1B2f27c0f57aka",
  }
};
